export const goodsLabels: {
  [key: string]: {
    heading: string;
    small: string;
  };
} = {
  doorsFields: {
    heading: 'Двери',
    small: 'дверь',
  },
  windowsFields: {
    heading: 'Окна',
    small: 'окно',
  },
};

export const goodsDefaultMeasurments: {
  [key: string]: {
    width: string;
    height: string;
  };
} = {
  doorsFields: {
    width: '0,7',
    height: '2',
  },
  windowsFields: {
    width: '2,04',
    height: '1,35',
  },
};

export const goodsHeadings: {
  [key: string]: string;
} = {
  doors: 'двери',
  windows: 'окна',
};

export const goodsErrors = {
  width: {
    required: 'Введите ширину',
    pattern: 'Формат: XX,XX',
  },
  height: {
    required: 'Введите высоту',
    pattern: 'Формат: XX,XX',
  },
  count: {
    pattern: 'Формат XX',
  },
};

export const tabListLabels = [
  {
    label: 'Длина х ширина',
    id: 'length',
  },
  {
    label: 'Площадь',
    id: 'area',
  },
];

export const SHOULD_BE_MORE_THEN_ZERO = 'Должна быть > 0';
